import { useDataProvider } from "react-admin";
import { v1 as uuidv1 } from "uuid";

export const useImageUpload = () => {
  const dataProvider = useDataProvider();

  const uploadImage = async (file: File): Promise<string> => {
    // Get a signed upload URL using the data provider
    const uploadLink = await dataProvider.getUploadLink(uuidv1());

    if (!uploadLink) {
      throw new Error("No upload link received");
    }

    // Upload to S3 using the signed URL
    const uploadResponse = await fetch(uploadLink.url, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload image");
    }

    return uploadLink.key;
  };

  return { uploadImage };
};
